import styled, { css } from "styled-components";
import { color, typeStyle, units } from "@m/alchemy-theme";
export const Pill = styled.div `
  position: relative;
  display: inline-block;

  ${typeStyle("labelM")}
  min-width: ${units(5.5)};

  ${({ fontSize }) => fontSize &&
    css `
      font-size: ${fontSize}px;
    `};

  padding: ${units(0.5)} ${units(1.5)};
  border-radius: ${units(3)};
  border-width: 1px;
  border-style: solid;
  border-color: ${color("hint")};
  color: ${color("typeHeader")};
  background-color: ${color("hint")};

  svg {
    height: ${units(1.75)};
    margin-right: ${units(0.5)};
  }
`;
